import React, {Fragment} from 'react'
import { Component } from 'react'
import {connect} from "react-redux";
import {IRootState} from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import {Route} from "react-router";
import {AccountInfo } from '@azure/msal-browser';
import {AuthActions} from "../../redux/reducers/Auth";
import {
    Client as GraphClient,
} from "@microsoft/microsoft-graph-client";

/* eslint import/no-webpack-loader-syntax: off */
import SignInWithMicrosoftLight from "!file-loader!../../images/sign_in_with_microsoft_light.svg"
import Shortcutter from "../Shortcutter";
import ApiService from "../ApiService";
import {MessageBarHelper} from "../../utils/MessageBarHelper";
import {UserAccessLevel} from "../../models/UserAccessRecord";

interface AuthorizeRouteProps {
    path: string,
    component: React.ElementType,
    user?: AccountInfo,
    userIsCdbEmployee: boolean;
    usersCdbAccessLevel: UserAccessLevel | undefined;
    apiService: ApiService;
    graphClient: GraphClient;
}

interface AuthorizeRouteState {
}

class AuthorizeRoute extends Component<AuthorizeRouteProps & DispatchProps,AuthorizeRouteState> {
    
    constructor(props: AuthorizeRouteProps & DispatchProps) {
        super(props);

        this.state = {
        };
    }

    render() {
        const { component: Component, ...rest } = this.props;

        return <Route {...rest}
            render={(props) => {
                if (this.props.user)
                {
                    return (
                        <Fragment>
                            <Component {...props} {...props.match.params} apiService={this.props.apiService} messageBar={new MessageBarHelper(this.props)} graphClient={this.props.graphClient} usersCdbAccessLevel={this.props.usersCdbAccessLevel}/> {/*assume component page's props is implementing ICDBPageProps*/}
                            {this.props.userIsCdbEmployee ? <Shortcutter history={props.history} match={props.match}/> : null}
                        </Fragment>
                    );
                }
                else
                {
                    return (
                        <div className="cdb-sign-in-page">
                            <h1>Sign in to Cloud Design Box</h1>
                            <p>To access this page, sign in with your Microsoft Account</p>
    
                            
                            <img className={"clickable"} src={SignInWithMicrosoftLight} onClick={() => {
                                this.props.dispatch(AuthActions.signIn());
                            }}/>
                        </div>
                    );
                }
            }} />
    }
}

export default connect((state: IRootState,ownProps: any): AuthorizeRouteProps => {
    return {
        ...ownProps,
        userIsCdbEmployee: state.auth.userIsCdbEmployee,
        usersCdbAccessLevel: state.auth.usersCdbAccessLevel,
        apiService: state.auth.apiService,
        graphClient: state.auth.graphClient,
        user: state.auth.user,
    }
})(AuthorizeRoute);
